import { useTranslation } from 'react-i18next';export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="shrink-0 border-t border-border-primary px-4 py-3">
      <div className="flex flex-col items-center justify-between gap-2 text-xs text-text-quaternary sm:flex-row">
        <div className="flex gap-4">
          <a
            href="https://budgetbakers.com/en/legal/privacy/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-text-secondary transition-colors"
          >
            {t('premium:legal.privacyPolicy')}
          </a>
          <a
            href="https://budgetbakers.com/en/legal/sharecost-terms/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-text-secondary transition-colors"
          >
            {t('premium:legal.termsOfService')}
          </a>
        </div>
        <div className="flex items-center gap-3">
          <span>&copy; {new Date().getFullYear()} {t('web:footer.budgetbakersAllRightsReserved')}</span>
          <span className="font-mono" title={t('web:footer.deployedAppVersion')}>
            v{__APP_VERSION__}
          </span>
        </div>
      </div>
    </footer>
  );
}
